import React, { Component } from 'react'

class Checkbox extends Component {

    static propTypes = {
        checked: React.PropTypes.bool.isRequired,
        onChecked: React.PropTypes.func.isRequired,
        onUnChecked: React.PropTypes.func.isRequired,
        label:  React.PropTypes.string.isRequired
    }

    constructor(props) {
        super(props);
        this.is_cut_down = false;
        this.onChangeHandler = this.onChangeHandler.bind(this);
    }

    onChangeHandler(event){
        if(this.props.checked)
          this.props.onUnChecked();
        else
          this.props.onChecked();
    }

    render() {
        var checked = this.props.checked ? "checked" : "";

        return (
           <div onClick={this.onChangeHandler} className="darkcheckbox">
            <input type="checkbox" value="None" name="check" checked={checked}/>
            <label></label>
            <span>{this.props.label}</span>
          </div>)
    }
}

export default Checkbox



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/Checkbox.js
 **/